import { UserRole } from 'core/constants';

export const CONTROL_FIELD = {
  name: 'controls__name',
  id: 'controls__id',
  category: 'controls__category',
  description: 'controls__description',
  owner: 'controls__owner',
  status: 'controls__status',
  dueDate: 'controls__dueDate',
} as const;

export const CONTROL_OWNER_FILTER = { licenses: 'risks', role: `-${UserRole.ArcOperator}` };

export enum ControlStatus {
  InPlace = 'inPlace',
  Proposed = 'proposed',
}

export enum ControlStatusFilter {
  InPlace = 'inPlace',
  Proposed = 'proposed',
  Archived = 'archived',
}

export const CONTROL_STATUS_LABEL: Record<ControlStatus | ControlStatusFilter, string> = {
  [ControlStatus.InPlace]: 'In place',
  [ControlStatus.Proposed]: 'Proposed',
  [ControlStatusFilter.Archived]: 'Archived',
};

export const DEFAULT_DUE_HOUR = 9;

export const STATUS_HELP =
  'The same on every risk this control is on. Proposed sends a control action to the owner, due on the due date.';

export const ARCHIVE_CONFIRMATION_MESSAGE =
  'It stays on the risks that already use it, but no one can add it to anything new. You can unarchive it at any time.';
